const baseDocumentsApiPath = 'organizations/:organizationId/documents';

export const documentsApiPaths = <const>{
    documents: baseDocumentsApiPath,
    deleteDocument: `${baseDocumentsApiPath}/:documentId`,
    images: `${baseDocumentsApiPath}/:documentId/images`,
};
